import * as angular from 'angular';

import { DirectiveDefinition } from './directiveDefinition';

class WtDraggableController implements angular.IController {
    classList: DOMTokenList;
    dragDisabled: boolean;
    dragObject: string;
    id: string;
    onDragStart: (value: { object: string }) => void;

    static $inject = ['$scope', '$element', '$attrs'];

    constructor(
        private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery,
        private _$attrs: any) {
    }

    $onInit() {
        // this gives us the native JS object
        const scope = this._$scope;
        const self = this;
        const el = this._$element[0];
        const attrs = this._$attrs;

        if (attrs['dragDisabled'] === 'true') {
            return;
        }
        const dragStart = function(e: DragEvent) {
            if (attrs['dragDisabled'] === 'true') {
                return false;
            }

            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('Text', this.id);
            try {
                // attrs ?
                // const param = scope[attrs['dragObject']];
                const param = self.dragObject;
                if (param) {
                    e.dataTransfer.setData('Text', JSON.stringify(param));
                }
                if (self.onDragStart) {
                    self.onDragStart({ object: param });
                    scope.$apply();
                }
            } catch (ex) {
                console.error(ex);
                return false;
            }
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            this.classList.add('drag');
            return true;
        };

        const dragEnd = function(_e: DragEvent) {
            if (self.dragDisabled) {
                return false;
            }
            this.classList.remove('drag');
            return true;
        };

        el.draggable = true;
        el.addEventListener('dragstart', dragStart, false);
        el.addEventListener('dragend', dragEnd, false);
    }
}

export const WtDraggableDirective: DirectiveDefinition = {
    directiveId: 'wtDraggable',
    restrict: 'A',
    controller: WtDraggableController,
    scope: {
        dragDisabled: '@',
        dragObject: '<?',
        onDragStart: '&?'
    },
    bindToController: true
};